import React from "react";
import { headericon, headermsg } from '../common/Assets/imgs';

const Header = ({title}) => {
    return (
        <div className="header">
            <div className="header-left">
                <h1 className="company-name">Khyathi Logistics</h1>
                <span className="subtitle">{title || ''}</span>
            </div>

            <div className="header-right">
                <div className="notification">
                    {/* <img
                        src={headermsg}
                        alt="message"
                        className="message-img"
                    /> */}
                </div>

                <img
                    src={headericon}
                    // src="https://i.pravatar.cc/40"
                    alt="profile"
                    className="profile-img"
                />
            </div>
        </div>
    );
};

export default Header;
